// DocumentoPrint.jsx (versión modal con generación PDF)
import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import html2pdf from "html2pdf.js";

export default function DocumentoPrint({ Plantilla, data }) {
  const ref = useRef();
  const [show, setShow] = React.useState(false);

  const handleDownloadPDF = () => {
    const element = ref.current;
    html2pdf().from(element).set({
      margin: 1,
      filename: `REMITO_NRO_0000_${data?.nroviaje || "SIN_NUMERO"}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
    }).save();
  };

  return (
    <>
      <Button variant="secondary" size="sm" className="ml-1" onClick={() => setShow(true)}>
        🖨️
      </Button>

      <Modal show={show} onHide={() => setShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Remito Transporte Danlu</Modal.Title>
        </Modal.Header>
          <Modal.Body>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div ref={ref}>
                <Plantilla data={data} />
              </div>
            </div>
          </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>Cerrar</Button>
          <Button variant="primary" onClick={handleDownloadPDF}>Descargar PDF</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
